// Helper function to format timestamp
export function formatTime(timestamp) {
  if (!timestamp) {
    console.warn('Timestamp is missing or invalid:', timestamp);
    return 'Unknown';
  }

  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      console.warn('Invalid date parsed from timestamp:', timestamp);
      return 'Unknown';
    }
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch (error) {
    console.error('Error parsing timestamp:', timestamp, error);
    return 'Unknown';
  }
}
